import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import { Success } from './UseGroupDynamicTypeaheadSelect/Types';

interface Props {
  inputValue: string;
  state: Success;
}

function NoOptionsMessage({ inputValue, state }: Props) {
  switch (state.kind) {
    case 'filtered':
      return (
        <div className="flex text-left text-sm items-center px-2 py-2 cursor-pointer">
          <T kind="No matches for {{name}}" name={inputValue} />
        </div>
      );
    case 'filtering':
    case 'option-selected':
    case 'ready':
      return (
        <div
          onClick={noop}
          className="flex text-left text-sm items-center px-2 py-2 cursor-pointer"
        >
          <T kind="Start typing to load options" />
        </div>
      );
  }
}
export default observer(NoOptionsMessage);
